import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUser = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 22,
	viewBox: "0 0 21 22",
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M10.8415 9.82264C10.7558 9.81407 10.653 9.81407 10.5587 9.82264C8.51868 9.75407 6.89868 8.08264 6.89868 6.0255C6.89868 3.9255 8.59582 2.21979 10.7044 2.21979C12.8044 2.21979 14.5101 3.9255 14.5101 6.0255C14.5015 8.08264 12.8815 9.75407 10.8415 9.82264Z",
		stroke: "white",
		strokeWidth: 1.28571,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M6.55571 12.9856C4.48143 14.3741 4.48143 16.637 6.55571 18.017C8.91286 19.5941 12.7786 19.5941 15.1357 18.017C17.21 16.6284 17.21 14.3656 15.1357 12.9856C12.7871 11.417 8.92143 11.417 6.55571 12.9856Z",
		stroke: "white",
		strokeWidth: 1.28571,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUser;
